export default {
  expandedPush: 'Развернутый пуш',
  open: 'Открыть',
  placeholder: 'Строка символов{{index}}',
  variable: 'Переменная',
  allButtons: 'Все кнопки',
  expandButtons: 'Развернуть кнопки',
  allPossibilities: 'Все возможности',
  selectVariant: 'Выберите вариант',
  allowCalling: 'Разрешить звонки',
  temporaryAllowCalling: 'Временно разрешить звонки',
  allowCallingToDate: 'Разрешить до {{date}}',
  notNow: 'Не сейчас',
  openMap: 'Открыть Яндекс.Карты',
  kilobytes: 'КБ',
};
